import React, { useState, useRef, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";


export const HsnPopup=(props)=> {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(true);

  return (
    <Transition.Root show={props.show} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[110]"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed bg-[rgba(0,0,0,0.6)] inset-0 transition" />
        </Transition.Child>
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center sm:items-end justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-0 sm:max-w-lg sm:w-full w-full max-w-[600px]">
                <div className="bg-white p-5 sm:px-3 sm:pb-4">
                <button className="flex items-center justify-between" onClick={props.onClose} >
                <h3 className="text-base text-secondary font-medium pb-3">Browse By Keyword</h3>
                    <svg className="absolute right-1 top-1 cursor-pointer focus:outline-none" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill="#000" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"/></svg>
                </button>
                <div className='flex flex-wrap items-center -mx-xsp pt-2'>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>A</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>B</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>C</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>D</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>E</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>F</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>G</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>H</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>I</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>K</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>L</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>M</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>N</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>O</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>P</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>Q</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>R</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>S</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>T</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>U</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>V</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>W</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>Y</p>
                            </div>
                            <div className='bg-anchor-blue p-xsp w-[50px] rounded-[4px] m-xsp'>
                                <p className='text-white text-sm text-center'>Z</p>
                            </div>
                        </div>
                </div> 
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default HsnPopup;
